export default function inventoryTransfer(state = null, action) {
  if (action.type === 'RECEIVE_INVENTORY_TRANSFER') {
    return action.payload
  }

  return state
}
